import src from "IMAGE";
export default { src, width: 955, height: 240, blurWidth: 0, blurHeight: 0};
